import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{attrs:{"grid-list-md":""}},[_c(VRow,{staticClass:"text-center",attrs:{"justify":"center"}},[_c(VCol,[_c('h1',[_vm._v("Storage")])])],1),_c(VDivider),_c(VLayout,{attrs:{"row":"","wrap":""}},[(_vm.quotaBytes > 0)?_c(VFlex,{attrs:{"xs12":""}},[_vm._v("Storage space usage: "+_vm._s(_vm.usageUiFriendly)+" / "+_vm._s(_vm.quotaUiFriendly)+" MB")]):_c(VFlex,{attrs:{"xs12":""}},[_vm._v("Storage space information unavailable")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }